import { defineComponent as _defineComponent } from 'vue'
import InputNumber from "primevue/inputnumber";
import { ref, inject, watch } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'commonNumber',
  props: {
    modelValue: { type: Number, required: true, default: 0, },
    name: { type: String, required: true, },
    parent: { type: String, default: "", },
    propname: { type: String, required: false, },
    mode: { type: String, default: "decimal", },
    v$: Object,
    IsreadOnly: { type: Boolean, default: false },
    allowEmpty: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    currency: { type: String, default: "USD" },
    inputclass: { type: String, default: "", },
    minFractionDigits: { type: String, default: "0" },
    maxFractionDigits: { type: String, default: "3" },
    useGrouping: { type: Boolean, default: false },
    onblur: { type: Function, default: null },
    onInput: { type: Function, default: null },
    blurParam: { type: [String, Number, Object], default: null }
},
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;
const InputValue = ref();
let Props = __props;
const IsValue = ref(false);
const onBlur = (value: any) => {
    updateValue(value == "" || value == null || !value ? 0 : value.trim());
    if (Props.onblur) {
        Props.onblur(Props.blurParam, value.trim());
    }
}
const updateValue = (value: any) => {
    emit("update:modelValue", value);
    if (Props.onInput)
        Props.onInput(value);
    IsValue.value = value !== undefined && value !== "";
};
//updateValue(Props.modelValue);
watch(() => Props.modelValue, () => {
    updateValue(Props.modelValue);
});
const onFocus = (e: any) => {
    if (Number(e.target.value) == 0) {
        emit("update:modelValue", null);
    }
}

const __returned__ = { emit, InputValue, get Props() { return Props }, set Props(v) { Props = v }, IsValue, onBlur, updateValue, onFocus, get InputNumber() { return InputNumber } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})